import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import logo from "../assets/logo.svg";
import logoSrmd from "../assets/eva_arrow-back-fill.svg";
import meal from "../assets/Frame1000002799.svg";
import { useLanguage } from "../../src/context/LanguageContext";
import translations from "../components/translations";
import LanguageToggle from "../components/LanguageToggle";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const ScanningHistory = () => {
  const { passId } = useParams();
  const [activeButton, setActiveButton] = useState("all");
  const { language } = useLanguage();
  const t = translations[language];
  const [isFiveLoading, setFiveIsLoading] = useState(false);
  const [ScanningHistoryData, setScanningHistoryData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const ScanningHistory = async () => {
      const payload = {
        groupId: passId,
      };
      try {
        setFiveIsLoading(true);
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/scanningHistory`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          }
        );
        const result = await response.json();

        if (result?.success) {
          const sortedArray = result?.data?.scanningHistory.sort(
            (a, b) =>
              new Date(`${b?.date}T${b?.time}.000Z`) -
              new Date(`${a?.date}T${a?.time}.000Z`)
          );
          setScanningHistoryData(sortedArray);
          setFiveIsLoading(false);
        } else {
          setFiveIsLoading(false);
          console.log("error");
        }
      } catch (error) {
        setFiveIsLoading(false);
        console.log(error);
      }
    };
    ScanningHistory();
  }, [passId]);

  const formatDateTime = (isoString) => {
    const date = new Date(isoString);

    // Options for date and time formatting
    const options = {
      weekday: "long",
      day: "numeric",
      month: "long",
      hour: "numeric",
      minute: "numeric",
      hour12: true, // Use 12-hour format with AM/PM
      timeZone: "UTC", // Use UTC time zone
    };

    // Format date and time
    const formattedDateTime = date.toLocaleString("en-GB", options);

    return formattedDateTime;
  };

  return (
    <>
      <Helmet>
        <title>Shrimad Rajchandra Mission Dharampur - Transaction</title>{" "}
        {/* Set specific title for EPassPage */}
      </Helmet>
      <div className={`bg-[#FAF6EF] h-auto min-h-screen ${window.innerWidth >= 1300 ? 'lg:px-[19rem]' : 'lg:px-[12rem]'}`}>
        <div className="flex flex-col gap-4 justify-center items-center ">
          <div className="w-2/3 sm:w-1/2 p-1">
            <img src={logo} alt="mission_logo" className="w-full h-full p-1" />
            <LanguageToggle />
          </div>
        </div>
        <div className="relative">
          <div className="relative bg-[#efede7] mt-10">
            <div className="absolute -top-10 left-1/2 transform -translate-x-1/2  flex flex-col justify-center items-center z-100 drop-shadow-lg">
              <div className="flex items-center justify-center bg-[#c66a10] p-2 px-4 min-w-[260px] text-white rounded-3xl mt-5 gap-3">
                <button onClick={() => navigate(-1)}>
                  <img className="w-5 h-5" alt="logo" src={logoSrmd} />
                </button>
                <h5 className="text-white px-4">{t.SHistory}</h5>
              </div>
            </div>
            <div className="flex gap-4 flex-col  items-center  bg-[#FAF6EF]">
              <div className="w-[90%] sm:w-[60%]">
                <div className="rounded-3xl bg-white flex flex-col  primary-bg p-3 sm:p-5 min-w-[300px] text-primary-text pt-8 shadow-lg  max-h-[500px] overflow-y-auto">
                  {isFiveLoading && (
                    <div className="flex items-center justify-center mt-10">
                      <div role="status">
                        <svg
                          aria-hidden="true"
                          class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-[#c66a10]"
                          viewBox="0 0 100 101"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="currentColor"
                          />
                          <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="currentFill"
                          />
                        </svg>
                      </div>
                    </div>
                  )}
                  {!isFiveLoading && (
                    <>
                      {ScanningHistoryData?.length > 0 && (
                        <div className="flex justify-between w-full pt-3">
                          <button
                            className={`flex items-center justify-center p-2 px-4 rounded-3xl w-[30%] shadow-lg ${
                              activeButton === "all"
                                ? "bg-[#c66a10] text-white"
                                : "bg-[#FAF6EF] text-[#c66a10] border-2 border-[#c66a10]"
                            }`}
                            onClick={() => setActiveButton("all")}
                          >
                            {t.meals.all}
                          </button>
                          <button
                            className={`flex items-center justify-center p-2 px-4 rounded-3xl shadow-lg w-[30%] ${
                              activeButton === "meals"
                                ? "bg-[#c66a10] text-white"
                                : "bg-[#FAF6EF] text-[#c66a10] border-2 border-[#c66a10]"
                            }`}
                            onClick={() => setActiveButton("meals")}
                          >
                            {t.meals.meal}
                          </button>
                          <button
                            className={`flex items-center justify-center p-2 px-4 rounded-3xl shadow-lg w-[30%] ${
                              activeButton === "buggy"
                                ? "bg-[#c66a10] text-white"
                                : "bg-[#FAF6EF] text-[#c66a10] border-2 border-[#c66a10]"
                            }`}
                            onClick={() => setActiveButton("buggy")}
                          >
                            {t.buggy}
                          </button>
                        </div>
                      )}
                      {ScanningHistoryData?.length === 0 && (
                        <div className="flex items-center justify-center mt-4 text-[#BD6A01] text-md sm:text-lg font-semibold">
                          {t.NoSData}
                        </div>
                      )}
                      {ScanningHistoryData?.length > 0 &&
                        ScanningHistoryData?.filter((billNo) => {
                          if (activeButton === "all") return true;
                          if (activeButton === "meals")
                            return billNo.categoryName !== "Buggy Pass";
                          if (activeButton === "buggy")
                            return billNo.categoryName === "Buggy Pass";
                          return false;
                        })?.map((billNo, index) => (
                          <div className="flex  justify-between  bg-[#F6F6F6]  mt-3 p-2 rounded-2xl">
                            <div className="flex  flex-col  w-full gap-1">
                              <span className="text-[#BD6A01] text-sm sm:text-md font-medium flex justify-between  w-full">
                                <span className="text-[#BD6A01] text-xs sm:text-lg font-medium flex justify-between items-center w-full">
                                  <span className="text-xs sm:text-lg  uppercase ">
                                   {billNo?.firstName}
                                  </span>
                                  <span className="  flex justify-center items-center">
                                  {billNo?.categoryName==='Buggy Pass'?<svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      viewBox="0 0 24 24"
                                      className="w-5 h-5"
                                    >
                                      <g fill="none">
                                        <path
                                          stroke="currentColor"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                          stroke-width="2"
                                          d="M6 19a2 2 0 0 1-2-2v-4m2 6v1.5a.5.5 0 0 0 .5.5v0a.5.5 0 0 0 .5-.5V19m-1 0h1m11 0a2 2 0 0 0 2-2v-4m-2 6v1.5a.5.5 0 0 1-.5.5v0a.5.5 0 0 1-.5-.5V19m1 0h-1M4 13V7m0 6h8m8 0V7m0 6h-8m-5 6h10M4 7V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2M4 7h8m8 0h-8m0 0v6"
                                        />
                                        <path
                                          fill="currentColor"
                                          fill-rule="evenodd"
                                          d="M4 13h16v6H4zm3 3a1 1 0 0 1 1-1h.001a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1m9-1a1 1 0 1 0 0 2h.001a1 1 0 1 0 0-2z"
                                          clip-rule="evenodd"
                                        />
                                        <path
                                          fill="currentColor"
                                          d="M4 5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2H4z"
                                        />
                                      </g>
                                    </svg>:
                                    <img
                                    className="w-6 h-6"
                                    alt="logo"
                                    src={meal}
                                  />}
                                   
                                    <span className="text-md sm:text-lg">
                                      {
                                        t.meals[
                                          billNo?.categoryName?.toLowerCase()
                                        ]
                                      }
                                    </span>
                                  </span>
                                </span>
                              </span>
                              <span className="text-[#999999] font-medium flex">
                                <span className="text-sm sm:text-md">
                                  {formatDateTime(
                                    `${billNo?.date}T${billNo?.time}.000Z`
                                  )}
                                </span>
                              </span>
                            </div>
                          </div>
                        ))}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ScanningHistory;
